import {
  type LaunchHubModel,
  LaunchHubModelSchema,
} from "@/lib/core/schemas/launch-hub";

/**
 * Fetches the account-level launch hub aggregate (characters, campaigns,
 * account facts). The route fails whole on any source error (no partial
 * aggregate — see the launch-hub-navigation plan's Global Constraints), so a
 * non-ok response always means "show the failed state", never a partial
 * render.
 */
export async function fetchLaunchHub(
  signal?: AbortSignal
): Promise<LaunchHubModel> {
  const res = await fetch("/api/account/launch", { signal });
  if (!res.ok) {
    throw new Error(`Failed to fetch launch hub (${res.status})`);
  }
  const body = await res.json();
  return LaunchHubModelSchema.parse(body);
}
